import { render, staticRenderFns } from "./Mantenimiento_agregar.vue?vue&type=template&id=01484074"
import script from "./Mantenimiento_agregar.vue?vue&type=script&lang=js"
export * from "./Mantenimiento_agregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports